module.exports = __webpack_public_path__ + "img/domit.a97c25b7.jpeg";